const Link = {
  baseStyle: {
    _hover: { textDecoration: "none", color: "blue.600" },
    _focus: { boxShadow: "none", outline: "none" },
  },
}

export default Link
